var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.btnType,_vm._g({tag:"o-button",attrs:{"disabled":_vm.disabled || _vm.credits < _vm.value,"type":_vm.type}},_vm.$listeners),[_vm._t("default"),_c('OCost',{attrs:{"value":_vm.value,"division":_vm.division}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }